import { IconWrapper } from '../runtime';
export default IconWrapper('qrcode', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M9.24998 9.0649V14.2477M11.75 14.2477V11.4061M11.7526 9.0649H13.95C14.1157 9.0649 14.25 9.19921 14.25 9.3649V14.2477M2.08571 6.75334H6.42215C6.60638 6.75334 6.75572 6.604 6.75572 6.41977V2.08333C6.75572 1.8991 6.60638 1.74976 6.42215 1.74976H2.08571C1.90148 1.74976 1.75214 1.8991 1.75214 2.08333V6.41977C1.75214 6.604 1.90148 6.75334 2.08571 6.75334ZM2.04987 14.2477H6.44799C6.61361 14.2477 6.74786 14.1134 6.74786 13.9478V9.54967C6.74786 9.38406 6.61361 9.2498 6.44799 9.2498H2.04987C1.88426 9.2498 1.75 9.38406 1.75 9.54967V13.9478C1.75 14.1134 1.88426 14.2477 2.04987 14.2477ZM9.55 6.7498H13.9421C14.1078 6.7498 14.2421 6.61548 14.2421 6.4498V2.0498C14.2421 1.88411 14.1078 1.7498 13.9421 1.7498H9.55C9.38431 1.7498 9.25 1.88411 9.25 2.0498V6.4498C9.25 6.61548 9.38431 6.7498 9.55 6.7498Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M3.5 3.49976H5V4.99976H3.5V3.49976Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M11 3.49976H12.5V4.99976H11V3.49976Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M3.5 10.9998H5V12.4998H3.5V10.9998Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});